import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { thousandSeparator } from "utils"
import { Button, CurrencyInput } from "components"
import { topupPaymentServiceOwner } from "services"
import PaymentGatewaySelector from "../../PaymentGatewaySelector"
import classes from "./TnmwtmWallet.module.scss"

const minTopup = 10000

const TnmwtmWallet = props => {
  const { setOpenTopupModal } = props

  const [t] = useTranslation()

  const wallet = useSelector(state => state.wallet)

  const [input, setInput] = useState("")
  const [sending, setSending] = useState(false)
  const [paymentGateway, setPaymentGateway] = useState("haghighi_a2a")

  const unmount = useRef(false)

  const handleDebt = () => {
    if (!wallet) return

    const debt =
      Math.max(
        Math.abs(
          Math.round((wallet.balance / 1000)) * 1000
        ),
        minTopup
      )

    setInput(String(debt))
  }

  const validateTopup = () => {
    if (Number(input) < minTopup) {
      toast.error(t("مقدار_افزایش_اعتبار_باید_بیشتر_از_cap_باشد", { cap: thousandSeparator(100000) }))

      return false
    }

    return true
  }

  const handleTopup = async () => {
    if (!validateTopup()) return

    setSending(true)

    try {
      const { gatewayUrl } =
        await topupPaymentServiceOwner({
          type: paymentGateway,
          amount: Number(input),
          // branchId
        })

      window.location.href = gatewayUrl
    } catch (err) {
      console.log(err)

      toast.error(t("عملیات_انجام_نشد"))

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  return (
    <div className={classes["container"]}>
      <div className={classes["row"]}>
        <CurrencyInput
          value={input}
          type="number"
          className={classes["input"]}
          label={t("مقدار_افزایش_اعتبار_تومان")}
          onChange={(value) => setInput(value)}
        />

        {
          wallet.balance < 0 &&
          <Button
            className={classes["button"]}
            onClick={handleDebt}
          >
            {t("اعمال_بدهی")}
          </Button>
        }
      </div>

      <PaymentGatewaySelector
        value={paymentGateway}
        disabled={sending}
        onChange={setPaymentGateway}
      />

      <div className={classes["footer"]}>
        <Button
          color="success"
          className={classes["topup"]}
          loading={sending}
          onClick={handleTopup}
        >
          {t("پرداخت")}
        </Button>

        <Button
          disabled={sending}
          onClick={() => setOpenTopupModal(false)}
          color="danger"
        >
          {t("بازگشت")}
        </Button>
      </div>
    </div>
  )
}

export default TnmwtmWallet
